import { IContainer } from '../../interface/container';
import { injectENV, injectLog } from '../../interface/util';
import { bindStoresMiddleware } from '../interface';
import buildMiddlewares from './builder';

function binder(container: IContainer) {
    const logger = injectLog(container);
    const env = injectENV(container);

    const middlewares = buildMiddlewares(logger, env);

    bindStoresMiddleware(middlewares, container);
}

export default binder;
